// Mock data for Efruz İnşaat website

export const projects = [
  {
    id: 1,
    name: "Skyline Residence",
    category: "completed",
    type: "Lüks Konut",
    location: "İstanbul, Beşiktaş",
    size: "12,500 m²",
    year: "2023",
    image: "https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYyNDUxNjAwfDA&ixlib=rb-4.1.0&q=85",
    description: "Modern mimari anlayışla tasarlanan, deniz manzaralı lüks konut projesi. 48 daireli bu prestijli yapı, akıllı ev sistemleri ve premium iç mekan tasarımı ile öne çıkmaktadır.",
    features: ["Akıllı Ev Sistemleri", "Deniz Manzarası", "Kapalı Otopark", "7/24 Güvenlik", "Yüzme Havuzu", "Fitness Center"],
    gallery: [
      "https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYyNDUxNjAwfDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800"
    ]
  },
  {
    id: 2,
    name: "Elysium Villas",
    category: "completed",
    type: "Lüks Villa",
    location: "Bodrum, Yalıkavak",
    size: "8,200 m²",
    year: "2022",
    image: "https://images.unsplash.com/photo-1724688078741-6d89e587e809?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYyNDUxNjAwfDA&ixlib=rb-4.1.0&q=85",
    description: "Bodrum'un eşsiz manzarasına hakim, özel havuzlu ve bahçeli lüks villa kompleksi. Doğal taş ve ahşap kullanımının ön planda olduğu tasarım.",
    features: ["Özel Havuz", "Peyzaj Bahçe", "Panoramik Manzara", "Özel Plaj Erişimi", "Smart Home", "Şömine"],
    gallery: [
      "https://images.unsplash.com/photo-1724688078741-6d89e587e809?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYyNDUxNjAwfDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800",
      "https://images.unsplash.com/photo-1600585154526-990dced4db55?w=800",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800"
    ]
  },
  {
    id: 3,
    name: "Metropol Plaza",
    category: "completed",
    type: "Ticari Proje",
    location: "Ankara, Çankaya",
    size: "25,000 m²",
    year: "2023",
    image: "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3NjI0NTE2MDV8MA&ixlib=rb-4.1.0&q=85",
    description: "Ankara'nın merkezinde konumlanan A+ ofis binası. LEED Gold sertifikalı, enerji verimli ve çevre dostu modern iş merkezi.",
    features: ["LEED Gold Sertifika", "A+ Ofis", "Kapalı Otopark (500 araç)", "Konferans Salonları", "Restoran", "VRF Klima Sistemi"],
    gallery: [
      "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3NjI0NTE2MDV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800",
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800",
      "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=800"
    ]
  },
  {
    id: 4,
    name: "Harmony Towers",
    category: "ongoing",
    type: "Karma Kullanım",
    location: "İzmir, Alsancak",
    size: "18,500 m²",
    year: "2024 (Devam Ediyor)",
    image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3NjI0NTE2MDV8MA&ixlib=rb-4.1.0&q=85",
    description: "İzmir'in kalbinde yükselen karma kullanımlı modern yaşam merkezi. Konut, ofis ve ticari alanları bir arada sunan prestijli proje.",
    features: ["Karma Kullanım", "80 Konut + Ofis", "Alışveriş Alanları", "Sosyal Tesis", "Yeşil Teras", "Güvenli Park"],
    gallery: [
      "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3NjI0NTE2MDV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800",
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800",
      "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=800",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800"
    ]
  },
  {
    id: 5,
    name: "Crown Business Center",
    category: "ongoing",
    type: "Ticari Proje",
    location: "İstanbul, Maslak",
    size: "32,000 m²",
    year: "2025 (Devam Ediyor)",
    image: "https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3NjI0NTE2MDV8MA&ixlib=rb-4.1.0&q=85",
    description: "Maslak'ın yeni simgesi olacak 30 katlı A++ ofis kulesi. Sürdürülebilir mimari ve teknolojik altyapısıyla geleceğin iş merkezi.",
    features: ["A++ Ofis Binası", "30 Kat", "Helipad", "Konferans Merkezi", "Restoran & Cafe", "Akıllı Bina Sistemleri"],
    gallery: [
      "https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3NjI0NTE2MDV8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800",
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800",
      "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=800"
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Lüks Konut Projeleri",
    description: "Modern mimari anlayışla tasarlanmış, yüksek kaliteli malzeme ve işçilikle inşa edilen premium konut projeleri.",
    icon: "building"
  },
  {
    id: 2,
    title: "Ticari Yapılar",
    description: "A+ ofis binaları, alışveriş merkezleri ve ticari kompleksler için entegre çözümler.",
    icon: "briefcase"
  },
  {
    id: 3,
    title: "Proje Yönetimi",
    description: "Başlangıçtan teslime kadar tüm süreçlerin profesyonel yönetimi ve koordinasyonu.",
    icon: "clipboard"
  },
  {
    id: 4,
    title: "Anahtar Teslim Projeler",
    description: "Tasarımdan ince işçiliğe kadar her detayın mükemmeliyetle tamamlandığı projeler.",
    icon: "key"
  },
  {
    id: 5,
    title: "Mimari Danışmanlık",
    description: "Uzman mimari ekibimizle projenizin her aşamasında profesyonel danışmanlık hizmeti.",
    icon: "pencil"
  },
  {
    id: 6,
    title: "Renovasyon & Restorasyon",
    description: "Mevcut yapıların modern standartlara uygun şekilde yenilenmesi ve güçlendirilmesi.",
    icon: "hammer"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmet Yılmaz",
    role: "Villa Sahibi",
    content: "Efruz İnşaat ile çalışmak gerçek bir ayrıcalıktı. Hayalindeki villayı tam olarak hayal ettiğimiz gibi inşa ettiler. Kalite ve detaylara gösterdikleri özen takdire şayan.",
    rating: 5
  },
  {
    id: 2,
    name: "Zeynep Kaya",
    role: "Şirket Yöneticisi",
    content: "Ofis binamızın inşaatında profesyonellik ve zamanında teslim konusunda kusursuz bir hizmet aldık. Efruz İnşaat'a güvenle işlerinizi emanet edebilirsiniz.",
    rating: 5
  },
  {
    id: 3,
    name: "Mehmet Demir",
    role: "Yatırımcı",
    content: "Birden fazla projede Efruz İnşaat ile çalıştık. Her seferinde beklentilerimizin üzerinde sonuçlar aldık. Gerçekten güvenilir bir iş ortağı.",
    rating: 5
  }
];

export const team = [
  {
    id: 1,
    name: "Erhan Furkan Uzun",
    role: "Kurucu & Genel Müdür",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400"
  },
  {
    id: 2,
    name: "Ayşe Yıldırım",
    role: "Proje Müdürü",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400"
  },
  {
    id: 3,
    name: "Can Özkan",
    role: "Baş Mimar",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400"
  },
  {
    id: 4,
    name: "Elif Aydın",
    role: "İnşaat Müdürü",
    image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400"
  }
];

export const companyInfo = {
  name: "Efruz İnşaat",
  tagline: "Lüksü Yeniden Tanımlıyor, Geleceği İnşa Ediyoruz",
  description: "Yüksek kaliteli konut ve ticari projelerde güvenilir ortağınız",
  mission: "Efruz İnşaat olarak misyonumuz, en yüksek kalite standartlarında, çevreye duyarlı ve sürdürülebilir projeler üreterek müşterilerimizin hayallerini gerçeğe dönüştürmektir.",
  vision: "Türkiye'nin ve bölgenin en güvenilir, yenilikçi ve kalite odaklı inşaat şirketi olmak.",
  values: [
    {
      title: "Kalite",
      description: "Her projede mükemmeliyeti hedefler, en yüksek kalite standartlarında çalışırız."
    },
    {
      title: "Güven",
      description: "Müşterilerimizle uzun vadeli, güvene dayalı ilişkiler kurar ve sözümüzü tutarız."
    },
    {
      title: "Yenilikçilik",
      description: "Sürekli gelişimi benimser, teknolojik yenilikleri projelerimize entegre ederiz."
    },
    {
      title: "Sürdürülebilirlik",
      description: "Çevreye duyarlı, enerji verimli ve gelecek nesillere yaşanabilir alanlar bırakırız."
    }
  ],
  contact: {
    phone: "+90 212 555 0123",
    email: "info@efruzinsaat.com",
    address: "Büyükdere Cad. No:125 Esentepe, Şişli, İstanbul"
  },
  social: {
    linkedin: "https://linkedin.com/company/efruz-insaat",
    instagram: "https://instagram.com/efruzinsaat",
    facebook: "https://facebook.com/efruzinsaat"
  }
};
